import { render, staticRenderFns } from "./rpt6.vue?vue&type=template&id=67e0a476&"
import script from "./rpt6.vue?vue&type=script&lang=js&"
export * from "./rpt6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports